import { CameraConstants } from "../Constants/CameraConstants";

export class Helpers {
    static sign(number: number) {
        return number > 0 ? 1 : -1;
    }

    static sum(arr: number[]) {
        return arr.reduce((a, b) => a + b, 0);
    }

}

export namespace CameraHelpers {
    export function isCameraZoomed(cameraIndex: CameraConstants) {
        return [
            CameraConstants.BigClose,
            CameraConstants.BigCloseB,
            CameraConstants.MediumClose,
            CameraConstants.MediumCloseB,
            CameraConstants.SmallClose,
            CameraConstants.SmallCloseB
        ].indexOf(cameraIndex) > -1;
    }
}
export namespace ConverUnitHelpers {
    export function mmTo2D(x: number) {
        return x * 0.156 - 170;
    }

    export function unit2DTomm(x: number) {
        return (x + 170) / 0.156;
    }
}